import * as React from 'react';

import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';

type Props = {
  variant: string;
  placement?: string;
  size?: number;
};
interface ColorVariants {
  [key: string]: string;
}
/**
 * Lock icon for webapp.
 * @param param0 Params.
 * @param param0.variant The variant of the lock icon.
 * @param param0.size The size of the lock icon.
 * @returns Icon.
 */
const LockIcon = ({ variant, size = 12, placement = 'right' }: Props) => {
  const colorVariants: ColorVariants = {
    basic_sciences: 'text-green-800',
    clinical_sciences: 'text-yellow-700',
  };

  const bgColorVariants: ColorVariants = {
    basic_sciences: 'bg-green-200',
    clinical_sciences: 'bg-amber-200',
  };

  const hoverVariants: ColorVariants = {
    basic_sciences: 'hover:bg-green-100',
    clinical_sciences: 'hover:bg-amber-100',
  };

  const color = colorVariants[variant];
  const backgroundColor = bgColorVariants[variant];
  const hover = hoverVariants[variant];

  if (!color) {
    return null;
  }

  const defaultClasses =
    placement === 'left' ? 'ml-0 py-0.5 pt-2 pb-1' : 'ml-[5px] px-2 py-0.5';

  return (
    <Box
      data-testid="locked-content"
      className={`${defaultClasses} ${backgroundColor} ${hover} hover:cursor-pointer inline min-w-[25px] w-[25px] h-[25px] rounded-full`}
    >
      <Icon icon={faLock} className={color} size="xs" data-testid="lock-svg" />
    </Box>
  );
};
export default LockIcon;
